export const useForeignMarkets = () => {
const { t } = useI18n()
const countries = [
    {
      title: t('aboutCompany.flags.countries.bg.title'),
      flag: '/images/abroad/flags/flag-bulgaria.png',
      url: t('aboutCompany.flags.countries.bg.url')
    },
    {
      title: t('aboutCompany.flags.countries.hr.title'),
      flag: '/images/abroad/flags/flag-croatia.png',
      url: t('aboutCompany.flags.countries.hr.url')
    },
    {
      title: t('aboutCompany.flags.countries.cz.title'),
      flag: '/images/abroad/flags/flag-czech.png',
      url: t('aboutCompany.flags.countries.cz.url')
    },
    {
      title: t('aboutCompany.flags.countries.sk.title'),
      flag: '/images/abroad/flags/flag-slovakia.png',
      url: t('aboutCompany.flags.countries.sk.url')
    },
    {
      title: t('aboutCompany.flags.countries.tr.title'),
      flag: '/images/abroad/flags/flag-turkey.png',
      url: t('aboutCompany.flags.countries.tr.url')
    }
  ]
  
  return {
    countries
  }
}